import { useEffect, useState } from 'react';
import { CollectionService } from '../services/collection-service.js';
import { CollectionCard } from '../components/CollectionCard.jsx';
import { QueryCache } from '../services/cache.js';
import { useLocale } from '../hooks/useLocale.jsx';
import { MyTabs } from '../components/MyTabs.jsx';

// /bookmarks route — kept for backwards-compat URL but the page is now
// just "My collections" (Phase 10-4 option B unified the two save concepts).
// Bookmarks-as-a-separate-list was retired; collections is the single
// save mechanism with a default 「Saved」 collection auto-created on first use.
export function Bookmarks({ user, onSignInRequest }) {
  const { t } = useLocale();
  const isLoggedIn = user && !user.isAnonymous;

  // Hydrate from cache so navigating from a collection back to /bookmarks
  // doesn't flash spinner before showing the collection list.
  const cached = isLoggedIn ? QueryCache.get(`myCollections:${user.uid}`) : null;
  const [collections, setCollections] = useState(cached || []);
  const [loading, setLoading] = useState(!cached && isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) { setLoading(false); return; }
    let mounted = true;
    (async () => {
      try {
        const cs = await CollectionService.listMine(user.uid);
        if (mounted) {
          setCollections(cs);
          QueryCache.set(`myCollections:${user.uid}`, cs);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [user]); // eslint-disable-line

  // MyDesigns 와 같은 sticky wrapper 로 감싼다. 이게 없으면 wrapper 의
  // padding-top: 0.5rem 만큼 (모바일) 탭 줄이 8px 위로 올라와서, Designs ↔
  // Collections 를 오갈 때 탭 높이가 미세하게 튄다. 스크롤 시 auto-hide
  // 동작도 덤으로 같아진다.
  const tabs = (
    <div className="feed-sticky-mobile">
      <MyTabs user={user} current="collections" />
    </div>
  );

  if (!user || user.isAnonymous) {
    return (
      <main className="main">
        {tabs}
        <p style={{ color: 'var(--text-secondary)', marginTop: '0.75rem' }}>{t('bookmarksSignInHint')}</p>
        {onSignInRequest && (
          <div className="controls" style={{ justifyContent: 'flex-start' }}>
            <button className="btn btn-primary" onClick={() => onSignInRequest()}>{t('signIn')}</button>
          </div>
        )}
      </main>
    );
  }

  if (loading) {
    return <main className="main">{tabs}<div className="loading"><div className="spinner"></div></div></main>;
  }

  return (
    <main className="main">
      {tabs}
      {collections.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)', marginTop: '0.75rem' }}>{t('bookmarksEmpty')}</p>
      ) : (
        <div className="collections-grid" style={{ marginTop: '1rem' }}>
          {collections.map(c => <CollectionCard key={c.id} collection={c} />)}
        </div>
      )}
    </main>
  );
}
